import React from 'react'
import ReactImage, { Modal, ModalGateway } from 'react-images'
import { Document, Page } from 'react-pdf'
import EurestoModal from 'Components/Modal'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import User from 'EurestoClass/User'
import Grid from '@material-ui/core/Grid'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      numPages: null,
      isOpen: props.isOpen || false,
      pageNumber: 0,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.numPages !== this.state.numPages || prevState.isOpen !== this.state.isOpen || prevState.pageNumber !== this.state.pageNumber) {
      this.setState({
        ...(prevState.numPages !== this.state.numPages && { numPages: this.state.numPages } || {}),
        ...(prevState.isOpen !== this.state.isOpen && { isOpen: this.state.isOpen } || {}),
        ...(prevState.pageNumber !== this.state.pageNumber && { pageNumber: this.state.pageNumber } || {}),
      })
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.numPages !== prevState.numPages || nextProps.isOpen !== prevState.isOpen || nextProps.pageNumber !== prevState.pageNumber) {
      return ({
        ...(nextProps.numPages !== prevState.numPages && { numPages: nextProps.numPages } || {}),
        ...(nextProps.isOpen !== prevState.isOpen && { isOpen: nextProps.isOpen } || {}),
        ...(nextProps.pageNumber !== prevState.pageNumber && { pageNumber: nextProps.pageNumber } || {}),
      })
    }
    else return null;
  }

  gotoPrevImg = _ => {
    this.setState({
      pageNumber: this.state.pageNumber - 1
    })
  }

  gotoNextImg = _ => {
    this.setState({
      pageNumber: this.state.pageNumber + 1
    })
  }

  closeImgsViewer = _ => {
    this.setState({
      pageNumber: 0,
      isOpen: false,
    }, () => {
      this.props.onClose && this.props.onClose()
    })
  }

  render() {
    if (this.props.images && this.props.images.length > 0 && this.props.images[0].src.split('.').slice('-1')[0].toLowerCase() === 'pdf') {
      return (
        <EurestoModal open={this.props.isOpen} onClose={() => (this.props.onClose && this.props.onClose())}
          xs>
          <EurestoDiv buttonsRight={[{
            icon: ' ei-commun_fermer',
            className: 'EurestoError--text EurestoText',
            cb: () => (this.props.onClose && this.props.onClose())
          }]} style={{
            margin: 0,
            padding: 10,
            maxHeight: User.CalculHeight.getHeightWanted(),
            height: User.CalculHeight.getHeightWanted(),
            overflowY: 'auto'
          }}>
            <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'} alignItems={'center'}
              direction={'column'}>
              <Document
                file={{ url: 'https://cors.euresto.com/' + this.props.images[0].src }}
                onLoadSuccess={this.onDocumentLoad}
              >
                <Page pageNumber={this.state.pageNumber + 1} />
              </Document>
              <p>
                {this.state.pageNumber !== 0 &&
                  <i className={'ei-commun_fleche ei-left cursor-pointer'} style={{ paddingRight: 5 }}
                    onClick={this.gotoPrevImg} />}
                Page {this.state.pageNumber + 1} of {this.state.numPages}
                {this.state.pageNumber !== this.state.numPages - 1 &&
                  <i className={'ei-commun_fleche ei-right cursor-pointer'} style={{ paddingLeft: 5 }}
                    onClick={this.gotoNextImg} />}
              </p>
            </Grid>
          </EurestoDiv>
        </EurestoModal>
      )
    } else if (this.props.images && this.props.images.length > 0) {
      return (
        <ModalGateway>
          {this.state.isOpen ? (
            <Modal onClose={this.closeImgsViewer}>
              <ReactImage
                views={this.props.images}
                currentIndex={this.state.pageNumber}
                theme={{
                  container: {
                    background: 'rgba(255, 255, 255, .9)'
                  },
                  close: {
                    fill: '#d40000',
                    opacity: .6,
                    transition: 'all 200ms',
                    ':hover': {
                      opacity: 1
                    }
                  },
                }
                }
              />
            </Modal>) : null}
        </ModalGateway>
      )
    } else {
      return <div style={{ display: 'none' }}></div>
    }

  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages })
  }

  onError(e) {
    logger.logError(e, 'error in file-viewer')
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/ApercuImage/index.js